import { render, staticRenderFns } from "./FormatObjectPropertyEditor.vue?vue&type=template&id=52b18152&scoped=true&"
import script from "./FormatObjectPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectPropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectPropertyEditor.vue?vue&type=style&index=0&id=52b18152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b18152",
  null
  
)

export default component.exports